import { FC } from "react";
import { Skeleton, Stack } from "@chakra-ui/react";

export const PaymentDestinationDataPending: FC = () => {
  return (
    <Stack spacing={0} mt="24px">
      <Skeleton h="20px" mb="8px" />

      <Stack spacing="8px">
        <Skeleton h="94px" borderRadius="16px" />
        <Skeleton h="94px" borderRadius="16px" />
      </Stack>
    </Stack>
  );
};
